import { createMemo } from 'react-use'
import { mapValueKey } from '@editorUtils'
import { useModelStore } from '@editorStores'
import { useGuidToElement } from '@editorHooks'

const mapPositions = (
  guidToElement: Record<string, ShapeObject | ShapeObjectLine>,
  rips: Rip[],
  lintels: Lintel[],
) => {
  return {
    ...guidToElement,
    ...mapValueKey(rips, 'position_guid'),
    ...mapValueKey(lintels, 'position_guid'),
  }
}

const useMapPositions = createMemo(mapPositions)

/**
 * All elements within model including rips & lintels
 * @returns guid to element map
 */
const useGuidToElementIncludingRips = () => {
  const rips = useModelStore(state => state.model.rips)
  const lintels = useModelStore(state => state.model.lintels)

  const guidToElement = useGuidToElement()

  return useMapPositions(guidToElement, rips, lintels)
}

export default useGuidToElementIncludingRips
